import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatDialog, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA,  } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass, DatePipe, AsyncPipe, JsonPipe } from '@angular/common';
import { Subject, BehaviorSubject, forkJoin, Observable, pipe, Subscription, switchMap, catchError, of, tap, map, take, throwError } from 'rxjs';

import { MercalinkFselibService, MercalinkAPIService } from '../mercalink-fselib.service';
import { ApiclientService } from '../shared/apiclient.service';	// Service for Mercalink server API endpoints

import * as dao from '../shared/dao';

export interface DialogData {
	server_url: string;
	area_baseurl: string;
	userid: number;
	numIdentFact: string;
}

export class Input {
	codeSpec!: string;
	codeConv!: string;
	zoneTarif!: string;
}

@Component({
  selector: 'lib-cps',
  imports: [MatDialogContent, FormsModule, MatRadioModule],
  templateUrl: './cps.component.html',
	styleUrls: ['../bs-dialog/bs-dialog.component.scss',  './cps.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class CpsComponent {
	readonly dialogRef = inject(MatDialogRef<CpsComponent>);
	readonly dialogdata:DialogData = inject<DialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler
	public loadingmsg: string | undefined = undefined;
	public errormsg: string | undefined = undefined;
	public empreinteCPS:dao.EmpreinteCPS | undefined = undefined;
	public user: any;
	public situationIndex: number = 0;
	public input: Input[] = new Array();	// Input values for codeSpec
	
	constructor(public fse: MercalinkFselibService, public mercalinkAPIService: MercalinkAPIService, private apiclientService: ApiclientService) {}
	
	ngOnInit() {
		this.loadingmsg = "Chargement";
		
		const user$ = this.apiclientService.getUser$(this.dialogdata.server_url, this.dialogdata.userid);	
		const cps$ = this.fse.lireCPS(this.dialogdata.area_baseurl, this.dialogdata.numIdentFact);		
		/*this.fse.lireCPS(this.dialogdata.area_baseurl).subscribe({*/
		forkJoin({ user: user$, cps: cps$ }).subscribe({
		  next: (response) => {
		    if (response && response.cps && response.user) {
		      if (response.user.error) {
						console.error('getUser$ failed with error: ', response.user.details);
						this.errormsg = 'Error calling getUser';
						this.loadingmsg = undefined;
					}
		
					if (response.cps.codeRetour != 0) {
						console.error('Error reading lireCPS response:', response.cps.libRetour);
						this.loadingmsg = undefined;
						this.errormsg = response.cps.libRetour;
					}
		      this.empreinteCPS = response.cps.empreinteCPS;
					this.user = response.user[0];
					console.log(`[ngOnInit] user: ${JSON.stringify(this.user, null, 2)}`);
					if (this.user && this.user.data?.FSE?.PS && this.user.data.FSE.PS?.numIdentFact) {	// Check for consistency on user.data
						let i;
						for (i = 0; i < this.empreinteCPS.situation.length; i++) {	// Set situationIndex to current value (c_user.data.FSE.PS.numIdentFact = numIdentFact from CPS)
							// console.log(`Testing situation ${i}: ${this.user.data.FSE.PS.numIdentFact} // ${this.empreinteCPS.situation[i].numIdentFact}`)
							this.situationIndex = i;
							if (this.empreinteCPS.situation[i].numIdentFact == this.user.data.FSE.PS.numIdentFact) break; 
						}
						
						if (i >= this.empreinteCPS.situation.length) {	// User numIdentFact does not exist on CPS 
							console.warn('User configuration error. User numIdentFact does not exist on CPS');
							this.loadingmsg = undefined;
							this.errormsg = 'Erreur de configuration utilisateur<br/>Cet utilisateur ne peut pas facturer';
							return;
						}
					} else {	// No numIdentFact on c_user.FSE.PS
						console.warn('User configuration error. No numIdentFact on c_user.FSE.PS');
						this.loadingmsg = undefined;
						this.errormsg = 'Erreur de configuration utilisateur<br/>Cet utilisateur ne peut pas facturer';
						return;
					}
					for (let i = 0; i < this.empreinteCPS.situation.length; i++) {	// All want well. Now replace 99 (undefined) w/ ''. Do NOT print 99
						this.input[i]=new Input();
						if (i==this.situationIndex) {
							this.input[i].codeSpec = (this.user.data.FSE.PS.spec=='99'?'':this.user.data.FSE.PS.spec);			// Init input value w/ saved value in user.data
							this.input[i].codeConv = (this.user.data.FSE.PS.codeConv=='9'?'':this.user.data.FSE.PS.codeConv);	
							this.input[i].zoneTarif = (this.user.data.FSE.PS.zoneTarif=='99'?'':this.user.data.FSE.PS.zoneTarif);
						} else {
							this.input[i].codeSpec = '';
							this.input[i].codeConv = '';
							this.input[i].zoneTarif = '';
						}
					}
					console.log(`[ngOnInit] input[]: ${JSON.stringify(this.input, null, 2)}`);
					this.loadingmsg = undefined;	
					this.errormsg = undefined;
		    } else {																							// Can't read CPS
		      console.warn('No data returned from lireCPS');
					this.loadingmsg = undefined;
					this.errormsg = 'No data returned from lireCPS or getUser';
		    }
		  },
		  error: (error) => {
		    console.error('Error calling lireCPS or getUser:', error);
				this.errormsg = 'Error calling lireCPS or getUser:', error;
				this.loadingmsg = undefined;
		  }
		});
	}
	
	onChangeInput(i: number) {	// Call API postUserDataUpdate, update c_user.data
		console.log(`[onChangeSituation] new index: ${i}`);
		if (this.input[this.situationIndex].codeSpec == '') this.input[this.situationIndex].codeSpec = '99';		// Do NOT send '', send 99
		if (this.input[this.situationIndex].codeConv == '') this.input[this.situationIndex].codeConv = '9';		
		if (this.input[this.situationIndex].zoneTarif == '') this.input[this.situationIndex].zoneTarif = '99';
		this.mercalinkAPIService.postUserDataUpdate$(this.dialogdata.server_url, this.user.id, 
				{	numLogSituation:(this.empreinteCPS?.situation[i].numLogSituation??0), // Will update numSituation
					codeSpec:(this.input[this.situationIndex].codeSpec),
					codeConv:(this.input[this.situationIndex].codeConv),
					codeZoneTarif:(this.input[this.situationIndex].zoneTarif),  
					numIdentFact:(this.empreinteCPS?.situation[i].numIdentFact??'')
				}).subscribe({
			next: (_res: any) => {	// Info message?
				this.situationIndex = i;
				if (this.input[this.situationIndex].codeSpec == '99') this.input[this.situationIndex].codeSpec = '';	// Do NOT print 99, print ''
				if (this.input[this.situationIndex].codeConv == '9') this.input[this.situationIndex].codeConv = '';	
				if (this.input[this.situationIndex].zoneTarif == '99') this.input[this.situationIndex].zoneTarif = '';
				// UPDATE In memory c_user value
			},
			error: (e) => {	// TODO Force dialog close?
				console.error("ERREUR Serveur : ", e.error);
				alert("ERREUR Serveur : " + e.error);
			}
		});		
	}	
	
	onCodeSpecChange(value: any, index:number) {
		// Convert to number
		  const num = Number(value);
		  // Check if it's a number and less than 100
		  if (!Number.isInteger(num) || (!(num >= 60 && num <= 68) && value !== '')) {
		    // You can set a default value, clear the input, or show a message
		    // Example: clear the input or set to '99'
		    // if (this.empreinteCPS) this.empreinteCPS.situation[this.situationIndex].codeSpec = '';
				this.input[index].codeSpec = '';
		    alert('Le code situation doit être sur 2 caractères max, entre 60 et 68');
		  } else {
		    this.onChangeInput(this.situationIndex);	// Force 'change' to self to update values on server
		  }
	}	
	
	onCodeConvChange(value: any, index:number) {
		const num = Number(value);
		if (!Number.isInteger(num) || (!(num == 1) && value !== '')) {
			this.input[index].codeConv = '';
		  alert('Le code convention doit être 1 ou vide');
		} else {
		  this.onChangeInput(this.situationIndex);	// Force 'change' to self to update values on server
		}		
	}	
	
	onZoneTarifChange(value: any, index:number) {
		if (value !== '00'  && value !== '') {
			this.input[index].zoneTarif = '';
		  alert('La zone tarifaire doit être 00 ou vide');
		} else {
		  this.onChangeInput(this.situationIndex);	// Force 'change' to self to update values on server
		}		
	}		
}
